var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat_log"},[_vm._v(" 444 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }